import { createFileRoute } from '@tanstack/react-router';
import { AiChatPage } from '@/pages/AiChatPage';

export const Route = createFileRoute('/_authed/ai')({
  component: AiChatPage,
});
